export function addToCart(product) {
  const event = {
    event: "add_to_cart",
    product: {
      id: product.id,
      title: product.title,
      url: product.url,
      vendor: product.vendor,
      price: product.price,
      variant_title: product.variant_title
    }
  }
  window.dataLayer.push(event)
}

export default addToCart;